// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3w3-_","productName":"Table_productName__2-Qyj"};